import React from 'react'
import { Flex } from '@rebass/emotion'

function HeaderInfoLeft() {
	return <Flex flexDirection="row" justifyContent={['space-around', 'flex-start']}></Flex>
}

export default HeaderInfoLeft
